import { render, staticRenderFns } from "./HistoricoLista.vue?vue&type=template&id=2c0a7874&scoped=true&"
import script from "./HistoricoLista.vue?vue&type=script&lang=js&"
export * from "./HistoricoLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a7874",
  null
  
)

export default component.exports